// removed by extract-text-webpack-plugin
module.exports = {"black":"jh_ji","white":"jh_jj","link":"jh_cx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Close/styles.module.css
// module id = 1092
// module chunks = 27